import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './styles';

const Loading = ({ heading }) => (
    <Styled.LoadingContainer>
        <Styled.Loading />
        <Styled.Heading>{heading}</Styled.Heading>
    </Styled.LoadingContainer>
);

Loading.defaultProps = {
    heading: undefined
};

Loading.propTypes = {
    heading: PropTypes.string
};

export default Loading;
